import blueRating from "./assets/star-rating-blue.svg";
import redRating from "./assets/star-rating-red.svg";
import cweTop from "./assets/cwe-top-25-logo.webp";
import owasp from "./assets/owasp.webp";
import prescientSecurityLogo from "./assets/prescient-security-logo.webp";
import socNonCpa from "./assets/soc-non-cpa.webp";
import facebook from "./assets/facebook.svg";
import instagram from "./assets/instagram.svg";
import X from "./assets/x.svg";
import linkedin from "./assets/linkedin.svg";
import youtube from "./assets/youtube.svg";

export const footerData = [
  {
    heading: "about.remo",
    subLinks: {
      about: "url:about",
      hiring: "url:hiring",
      "contact.sales": "url:contact.sales",
    },
  },
  {
    heading: "platform",
    subLinks: {
      "agency.program": "url:agency.program",
      demo: "url:demo",
      pricing: "url:pricing",
      product: "url:product",
    },
  },
  {
    heading: "resources",
    subLinks: {
      academy: "url:academy",
      blog: "url:blog",
      "custom.floorplans": "url:custom.floorplans",
      faqs: "url:faqs",
      "help.center": "url:remo.helpdesk",
      marketplace: "url:marketplace",
      "mic.cam.test": "url:geartest",
      "success.stories": "url:success.stories",
    },
  },
  {
    heading: "policies",
    subLinks: {
      privacy: "url:privacy",
      "cookie.notice": "url:cookie.notice",
      "security.whitepaper": "url:security.whitepaper",
      "data.protection": "url:data.protection",
      "users.terms.of.service": "url:users.terms.of.service",
      "customers.terms.of.service": "url:customers.terms.of.service",
      accessibility: "url:accessibility",
    },
  },
  {
    heading: "use.cases",
    subLinks: {
      "law.firm": "url:law.firm",
      "human.resources": "url:human.resources",
      "virtual.hybrid.events": "url:virtual.hybrid.events",
      "enterprise.corporate": "url:enterprise.corporate",
      "virtual.networking": "url:virtual.networking",
      "professional.associations": "url:professional.associations",
      "higher.education": "url:higher.education",
    },
  },
];

export const certificateLogos = [
  { src: prescientSecurityLogo, alt: "prescient-security-logo" },
  { src: socNonCpa, alt: "soc-non-cpa" },
  { src: owasp, alt: "owasp" },
  { src: cweTop, alt: "cwe-top" },
];

export const ratings = [
  {
    src: blueRating,
    alt: "blue-rating",
    text: "reviews.capterra",
    link: "url:blue.rating",
  },
  {
    src: redRating,
    alt: "red-rating",
    text: "reviews.g2",
    link: "url:red.rating",
  },
];

export const socialMediaPlatforms = [
  {
    src: facebook,
    alt: "facebook",
    href: "url:facebook",
  },
  {
    src: instagram,
    alt: "instagram",
    href: "url:instagram",
  },
  {
    src: X,
    alt: "X",
    href: "url:twitter",
  },
  {
    src: linkedin,
    alt: "linkedin",
    href: "url:linkedin",
  },
  {
    src: youtube,
    alt: "youtube",
    href: "url:youtube",
  },
];
